import axios from 'axios';
import { env } from '../../config/env';
import type {
  IConnectRewardPartnerRequest,
  IConnectRewardPartnerResponse,
  IDisconnectRewardPartnerRequest,
  IDisconnectRewardPartnerResponse,
} from '../../models/reward-partners';
import { createStandardResponse, StandardResponse } from '../../models/standard-response';

export const connectRewardPartner = async (
  data: IConnectRewardPartnerRequest,
): Promise<StandardResponse<IConnectRewardPartnerResponse>> => {
  const response = await axios.post(
    `${env.VITE_API_SERVER}/${env.VITE_API_VERSION}/driver/reward-partner/connect`,
    data,
  );
  return createStandardResponse<IConnectRewardPartnerResponse>(
    response.status,
    response.data.data,
    response.data.message,
    null,
  );
};

export const disconnectRewardPartner = async (
  data: IDisconnectRewardPartnerRequest,
): Promise<StandardResponse<IDisconnectRewardPartnerResponse>> => {
  const response = await axios.post(
    `${env.VITE_API_SERVER}/${env.VITE_API_VERSION}/driver/reward-partner/disconnect`,
    data,
  );
  return createStandardResponse<IDisconnectRewardPartnerResponse>(
    response.status,
    response.data.data,
    response.data.message,
    null,
  );
};
